<div *ngIf="showBackdrop"
     #dialogBackdrop
     class="backdrop"
     [class.visible]="dialogVisible"
     (click)="onBackdropClick()"></div>
<div #dialog
     class="dialog"
     [class.moving]="!!isMoving"
     [class.pre-visible]="dialogPreVisible"
     [class.visible]="dialogVisible"
     [style.left]="!!isMoving && moveData ? (moveData.leftX + 'px') : null"
     [style.top]="!!isMoving && moveData ? (moveData.topY + 'px') : null"
     cdkTrapFocus
     (transitionend)="onTransitionEnd($event)">
  <div #dialogHiddenFocus
       *ngIf="data.autoFocus === false"
       tabindex="0"></div>
  <ng-container cdkPortalOutlet></ng-container>
</div>
